export const getIsInitialized = (state) => state.app.isInitialized;